//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Fragment } from "vue-fragment";
import { uniqueId } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "BooleanArgument",
  components: {
    Fragment
  },
  props: {
    value: {
      type: Boolean,
      default: null
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      localValue: this.value,
      uniqueId: uniqueId("automation_boolean_input_")
    };
  },
  watch: {
    value(newValue) {
      if (newValue !== this.localValue) {
        this.localValue = newValue;
      }
    }
  },
  methods: {
    handleToggleBoolean({
      target
    }) {
      this.$emit("input", target.checked);
    }
  }
});